module.exports = __webpack_public_path__ + "media/derlon_sanctuary.344b6e0d.wav";